import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditExperience = () => {

    const [exprience, setExperience] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://seo-09-457b9942ea0a.herokuapp.com/experiences/${id}`)
            .then((res) => res.json())
            .then((info) => setExperience(info));
    }, [id]);



    const handleExperienceSection = (event) => {
        event.preventDefault();

        const experienceText = event.target.experienceText.value;
        const experienceHeading = event.target.experienceHeading.value;
        const experienceImage = event.target.experienceImage.value;
      
       




        const experienceSection = {

            experienceText,
            experienceHeading,
            experienceImage,
     



        };

        const url = `https://seo-09-457b9942ea0a.herokuapp.com/update-experiences/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(experienceSection),
        })
            .then((res) => res.json())
            .then((result) => {

                alert('Experience Section is Updated');
            });
    };



    return (
        <>
            <HeaderBottom></HeaderBottom>
            <section id="services" class="services-area pt-120 pb-90 fix mb-4" >
                <div class="container">
                    <div class="row">

                    </div>
                    <div class="row">

                        <div class="col-lg-8 col-md-12">
                            <h2> Update Experience </h2>

                                <form class="contact-form " onSubmit={handleExperienceSection}>
                                    <div class="row">

                                        <div className="col-lg-12 col-md-12 mb-3">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="experienceText" defaultValue={exprience.experienceText} placeholder="Section Text" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 mb-3">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="experienceHeading" defaultValue={exprience.experienceHeading} placeholder="Section Heading" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 mb-3">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="experienceImage" defaultValue={exprience.experienceImage} placeholder="Image URL" required />
                                            </div>
                                        </div>

                                       
                                        
                                        <div class="slider-btn">
                                            <button class="btn btn-md  btn-gradient animation" data-animation="fadeInRight" data-delay=".8s"> Update Recent Project </button>
                                        </div>
                                    </div>

                                </form>
                            



                        </div>


                    </div>
                </div>
            </section>
        </>
    );
};

export default EditExperience;